import type { ConsentChoices, ConsentRecord, ConsentSource } from './types';
import { COOKIE_POLICY_VERSION } from './types';

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

export interface RecordConsentParams {
  choices: ConsentChoices;
  source: ConsentSource;
  sessionId?: string;
  bearerToken?: string;
}

export async function recordConsent({ choices, source, sessionId, bearerToken }: RecordConsentParams): Promise<ConsentRecord> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (sessionId) headers['X-Session-ID'] = sessionId;
  if (bearerToken) headers['Authorization'] = `Bearer ${bearerToken}`;

  const res = await fetch(`${API_BASE}/api/v1/consent`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      documentVersion: COOKIE_POLICY_VERSION,
      choices,
      source,
    }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`recordConsent failed: ${res.status} ${text}`);
  }
  return (await res.json()) as ConsentRecord;
}

export async function getCurrentConsent(bearerToken: string): Promise<ConsentRecord | null> {
  const res = await fetch(`${API_BASE}/api/v1/consent/me`, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
    credentials: 'include',
  });
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(`getCurrentConsent failed: ${res.status}`);
  }
  return (await res.json()) as ConsentRecord;
}
